var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25001 13.831V9.375C6.25001 5.92322 9.04823 3.125 12.5 3.125V3.125C15.9518 3.125 18.75 5.92322 18.75 9.375L18.75 13.831L20.4519 15.533C20.6961 15.7772 20.8333 16.1084 20.8333 16.4537V16.9271C20.8333 17.6462 20.2503 18.2292 19.5312 18.2292H5.46871C4.74959 18.2292 4.16663 17.6462 4.16663 16.9271V16.4537C4.16663 16.1084 4.30381 15.7772 4.548 15.533L6.25001 13.831Z",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 21.0938C13.3897 22.1355 11.6102 22.1355 10.4166 21.0938",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a1576e7b4f07ed8be48606dd95c31932.svg";
export { ForwardRef as ReactComponent };